import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDownLarge = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M9.28125 14.7187L3.28125 8.71875C2.875 8.34375 2.875 7.6875 3.28125 7.3125C3.65625 6.90625 4.3125 6.90625 4.6875 7.3125L10 12.5937L15.2812 7.3125C15.6562 6.90625 16.3125 6.90625 16.6875 7.3125C17.0938 7.6875 17.0938 8.34375 16.6875 8.71875L10.6875 14.7187C10.3125 15.125 9.65625 15.125 9.28125 14.7187Z"
	})
});
const ForwardRef = forwardRef(SvgArrowDownLarge);
export default ForwardRef;
